export function getHintsList(state) {
	return state.hints.hintsList;
}

export function getCurrentHintOnDisplay(state) {
	return state.hints.currentHint;
}

export function areHintsDisabled(state) {
	return state.hints.areHintsDisabled
		|| localStorage.getItem('areHintsDisabled') === 'true';
}
